/**
 * Button that renders an anchor so users can right-click to open in a new tab.
 */

import type { ParentComponent } from "solid-js";
import { Button, type Props as ButtonProps } from "./Button";

export type Props = Omit<ButtonProps, "as" | "type"> & {
	href: string;
};

export const ButtonLink: ParentComponent<Props> = (props) => {
	return <Button as="a" {...props} />;
};
